import BarChartLabel from '../../../components/generic/BarChartLabel';
import { useEffect, useState } from 'react';
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, XAxis, YAxis } from 'recharts';

export default function TimeSpentChart({ timeData }) {
  const [chartData, setChartData] = useState([]);
  const [yAxisDomain, setYAxisDomain] = useState([0, 100]);

  useEffect(() => {
    if (!timeData) return undefined;

    const timeDataArray = Object.values(timeData);
    const filteredData = timeDataArray?.filter((item) => item?.subject?._id !== 'overall');
    if (filteredData?.length) {
      const computedChartData = filteredData.map((item) => ({
        name: item.subject.title,
        timeSpent: item.timeSpent,
        color: item.subject.color,
      }));

      setChartData(computedChartData);
      const max = Math.max(...computedChartData.map((item) => item.timeSpent));
      setYAxisDomain([0, Math.ceil(max * 1.1)]);
    } else {
      setChartData([]);
      setYAxisDomain([0, 100]);
    }
  }, [timeData]);

  if (!chartData || chartData.length === 0) return null;

  return (
    <div className="h-[300px] border border-t-0 rounded-b-xl border-[var(--q3-stroke-light)] pt-4 pointer-events-none">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} barSize={40} margin={{ top: 20, right: 20, left: 20, bottom: 20 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--q3-stroke-light)" />
          <XAxis
            dataKey="name"
            tick={{ fontSize: 12, fill: 'var(--q3-neutral-light)' }}
            stroke="var(--q3-stroke-light)"
            axisLine={{ stroke: 'var(--q3-stroke-light)' }}
          />
          <YAxis
            domain={yAxisDomain}
            tick={{ fontSize: 12, fill: 'var(--q3-neutral-light)' }}
            width={50}
            stroke="var(--q3-stroke-light)"
            axisLine={{ stroke: 'var(--q3-stroke-light)' }}
            tickFormatter={(value) => `${value} min`}
          />

          <Bar dataKey="timeSpent" label={<BarChartLabel />} radius={[4, 4, 0, 0]}>
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
